import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserModel } from '@common/models/User.model';
import { currentUserSubject } from '../services/user.service';

@Injectable()
export class AuthGuard {
    private currentUser: UserModel;

    constructor(private router: Router) {
        currentUserSubject.subscribe((user) => {
            this.currentUser = user;
        });
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // status - user available
        const status = !!this.currentUser;

        // user not logged in
        if (!status) {
            // redirect to login
            if (state.url) {
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            } else {
                this.router.navigate(['/login']);
            }
        }

        return status;
    }
}
